import {
    ParsedRaydiumPoolRaw,
    ParsedRaydiumPool,
    ParsedRaydiumPosition,
    ParsedRaydiumPositionRaw,
    ParsedOrcaWhirlpoolRaw,
    ParsedOrcaWhirlpool,
    ParsedOrcaPosition,
    ParsedOrcaPositionRaw,
    ClpPositionInfoRaw,
    ClpPositionInfo,
    ParsedWhirlpoolRewardInfoRaw,
    ParsedWhirlpoolRewardInfo
} from "@bridgesplit/abf-sdk";
import BN from "bn.js";
import { mapValues, mapRecordArray } from "@bridgesplit/utils";

export function parsedWhirlpoolPositions(raw: ClpPositionInfoRaw): ClpPositionInfo {
    return {
        whirlpoolsToPositions: mapRecordArray(raw.whirlpoolsToPositions, parseParsedWhirlpoolPosition),
        whirlpools: mapValues(raw.whirlpools, parseParsedWhirlpool),
        raydiumPoolsToPositions: mapRecordArray(raw.raydiumPoolsToPositions, parseParsedRaydiumPosition),
        raydiumPools: mapValues(raw.raydiumPools, parseParsedRaydiumPool)
    };
}

function parseParsedRaydiumPool(raw: ParsedRaydiumPoolRaw): ParsedRaydiumPool {
    return {
        ammConfig: raw.ammConfig,
        owner: raw.owner,
        tokenMint0: raw.tokenMint0,
        tokenMint1: raw.tokenMint1,
        tokenVault0: raw.tokenVault0,
        tokenVault1: raw.tokenVault1,
        observationKey: raw.observationKey,
        mintDecimals0: raw.mintDecimals0,
        mintDecimals1: raw.mintDecimals1,
        tickSpacing: raw.tickSpacing,
        tickCurrent: raw.tickCurrent,
        liquidity: new BN(raw.liquidity),
        sqrtPriceX64: new BN(raw.sqrtPriceX64),
        feeGrowthGlobal0X64: new BN(raw.feeGrowthGlobal0X64),
        feeGrowthGlobal1X64: new BN(raw.feeGrowthGlobal1X64),
        protocolFeesToken0: new BN(raw.protocolFeesToken0),
        protocolFeesToken1: new BN(raw.protocolFeesToken1),
        swapInAmountToken0: new BN(raw.swapInAmountToken0),
        swapOutAmountToken1: new BN(raw.swapOutAmountToken1),
        swapInAmountToken1: new BN(raw.swapInAmountToken1),
        swapOutAmountToken0: new BN(raw.swapOutAmountToken0)
    };
}

function parseParsedRaydiumPosition(raw: ParsedRaydiumPositionRaw): ParsedRaydiumPosition {
    return {
        nftMint: raw.nftMint,
        poolId: raw.poolId,
        tickLowerIndex: raw.tickLowerIndex,
        tickUpperIndex: raw.tickUpperIndex,
        liquidity: new BN(raw.liquidity),
        feeGrowthInside0LastX64: new BN(raw.feeGrowthInside0LastX64),
        feeGrowthInside1LastX64: new BN(raw.feeGrowthInside1LastX64),
        tokenFeesOwed0: new BN(raw.tokenFeesOwed0),
        tokenFeesOwed1: new BN(raw.tokenFeesOwed1)
    };
}

function parseParsedWhirlpoolRewardInfo(raw: ParsedWhirlpoolRewardInfoRaw): ParsedWhirlpoolRewardInfo {
    return {
        mint: raw.mint,
        vault: raw.vault,
        authority: raw.authority,
        emissionsPerSecondX64: new BN(raw.emissionsPerSecondX64),
        growthGlobalX64: new BN(raw.growthGlobalX64)
    };
}

function parseParsedWhirlpool(raw: ParsedOrcaWhirlpoolRaw): ParsedOrcaWhirlpool {
    return {
        whirlpoolsConfig: raw.whirlpoolsConfig,
        tickSpacing: raw.tickSpacing,
        feeRate: raw.feeRate,
        protocolFeeRate: raw.protocolFeeRate,
        liquidity: new BN(raw.liquidity),
        sqrtPrice: raw.sqrtPrice,
        protocolFeeOwedA: new BN(raw.protocolFeeOwedA),
        protocolFeeOwedB: new BN(raw.protocolFeeOwedB),
        tokenMintA: raw.tokenMintA,
        tokenVaultA: raw.tokenVaultA,
        feeGrowthGlobalA: new BN(raw.feeGrowthGlobalA),
        tokenMintB: raw.tokenMintB,
        tokenVaultB: raw.tokenVaultB,
        feeGrowthGlobalB: new BN(raw.feeGrowthGlobalB),
        rewardLastUpdatedTimestamp: new BN(raw.rewardLastUpdatedTimestamp),
        rewardInfos: raw.rewardInfos.map(parseParsedWhirlpoolRewardInfo),
        tokenA: undefined, //Expanded tpye
        tokenB: undefined
    };
}

function parseParsedWhirlpoolPosition(raw: ParsedOrcaPositionRaw): ParsedOrcaPosition {
    return {
        address: raw.address,
        whirlpool: raw.whirlpool,
        positionMint: raw.positionMint,
        totalLiquidity: new BN(raw.totalLiquidity),
        lowerSqrtPrice: new BN(raw.lowerSqrtPrice),
        upperSqrtPrice: new BN(raw.upperSqrtPrice),
        liquidityAmounts: raw.liquidityAmounts,
        feeAmounts: raw.feeAmounts,
        rewardAmounts: raw.rewardAmounts
    };
}
